export const copy = (text: string) => {
  const target = document.createElement('textarea');
  target.style.position = 'absolute';
  target.style.left = '-9999px';
  target.style.top = '0';
  target.id = '__hiddenCopyText__';
  document.body.appendChild(target);
  target.textContent = text;

  // 현재 스크롤 위치 저장
  const scrollY = window.scrollY;

  // 텍스트 선택 및 복사
  target.select();

  let succeed;

  try {
    succeed = document.execCommand('copy');
  } catch (err) {
    succeed = false;
  }

  if (target.parentNode !== null) {
    target.parentNode.removeChild(target);
  }

  // 이전 스크롤 위치로 복원
  window.scrollTo(0, scrollY);

  if (succeed) {
    return true;
  } else {
    return false;
  }
};
